import { Users } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall, getDateAndTime, handleDateChange, sanitizeInput } from "../../CommonComponents/CustomHooks";
import { CommonApiData, initializeFilterData } from "../../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../../CommonComponents/ExportData";
import { AutoCompleteBoxNew, DateBox, FormButton, InputBox } from "../../CommonComponents/InputBox";
import { Table } from "../../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const UserLogReport = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [formData, setFormData] = useState({
        logDateFrom: getDateAndTime(7).date,
        logDateTo: getDateAndTime().date,
        formName: '',
        logType: '',
        user: '',
    });

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...formData,
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/UserLogReport`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
        } else if (res.Status === 'ERROR') {
            setTableData([]);
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            logDateFrom: getDateAndTime(7).date,
            logDateTo: getDateAndTime().date,
            formName: '',
            logType: '',
            user: '',
        })
        filterData.SearchText = ''
        inputrefs.current['txtFromDate'].focus()
        getGroupMasterData()
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };

    const extraPayload = {
        ...filterData,
        ...formData,
        "loginCompanyCode": CommonApiData().companyCode,
    }


    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    useEffect(() => {
        inputrefs.current['txtFromDate'].focus()
        document.title = 'User Log Report'
        getGroupMasterData()
    }, [sortConfig]);

    return (
        <>
                <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                            <Users className="w-6 h-6 text-teal-600" />
                            <h2 className="text-xl font-semibold text-gray-800">User Log Report</h2>
                        </div>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className="row">
                                    <DateBox
                                        inputrefs={inputrefs}
                                        label="From Date"
                                        required={true}
                                        placeholder="DD-MMM-YYYY"
                                        id='txtFromDate'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtToDate'].focus()
                                            };
                                        }}
                                        selected={formData.logDateFrom === '' ? '' : new Date(formData.logDateFrom)}
                                        onChange={(e) => handleDateChange(e, setFormData, formData, 'logDateFrom')}
                                    />


                                    <DateBox
                                        inputrefs={inputrefs}
                                        label="To Date"
                                        placeholder="DD-MMM-YYYY"
                                        id='txtToDate'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtFormName'].focus()
                                            };
                                        }}
                                        selected={formData.logDateTo === '' ? '' : new Date(formData.logDateTo)}
                                        onChange={(e) => handleDateChange(e, setFormData, formData, 'logDateTo')}
                                    />

                                    <InputBox
                                        label='Form Name'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtLogType'].focus()
                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        id="txtFormName"
                                        placeholder='Enter Form Name'
                                        type="text"
                                        maxLength='30'
                                        value={formData.formName}
                                        onChange={(e) => setFormData({ ...formData, formName: sanitizeInput(e.target.value) })}
                                    />
                                    <InputBox
                                        label='Log Type'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtUser'].focus()
                                            }
                                        }}
                                        inputrefs={inputrefs}
                                        id="txtLogType"
                                        placeholder='Enter Log Type'
                                        type="text"
                                        maxLength='30'
                                        value={formData.logType}
                                        onChange={(e) => setFormData({ ...formData, logType: sanitizeInput(e.target.value) })}
                                    />

                                <AutoCompleteBoxNew
                                    id="txtUser"
                                    required
                                    label='User'
                                    placeholder="Enter User"
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') { inputrefs.current["txtbtnSub"].focus(); };
                                    }}

                                    autocompleteType='GetUser'
                                    value={formData.user || ''}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, user: newInputValue })
                                        }
                                    }}
                                />

                                    
                                </div>
                            </div>
                        </div>


                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'txtbtnSub'}
                            inputrefs={inputrefs}
                            handleSearch={getGroupMasterData}
                            save={false}          
                            search={true}  
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/User/UserLogReport`, extraPayload, 'User Log Report')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
                <Table
                    loading={isLoading}
                    PageName={'UserLogReport'}
                    handleFilter={() => {
                        getGroupMasterData(1)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                    Filter={false}
                    onlyFilterPage={true}
                />
        </>
    )
}
export default UserLogReport;